module.exports = __webpack_public_path__ + "img/bottom_logo.7de9aadc.png";